// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import { PermissionGroup, Person, User, UserExternalNotificationFrequency, UserStatus } from "../../../Utilities";

export type Base = {
	email: User["email"];
	timeZoneName: User["timeZoneName"];
	permissionGroupIDs: PermissionGroup["id"][];
	personID: Person["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, "email">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	email: "",
	timeZoneName: "",
	permissionGroupIDs: [],
	personID: null,
};

export type Detail = Base & {
	status: User["status"] | null;
	passwordUpdatedAt: User["passwordUpdatedAt"] | null;
	isCurrent: User["isCurrent"];
	externalNotificationFrequency: User["externalNotificationFrequency"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export const externalNotificationFrequencyOptions = [
	{ value: UserExternalNotificationFrequency.Daily },
	{ value: UserExternalNotificationFrequency.Never },
	{ value: UserExternalNotificationFrequency.Weekly },
];

export const statusOptions = [
	{ value: UserStatus.Active },
	{ value: UserStatus.Created },
	{ value: UserStatus.Disabled },
	{ value: UserStatus.Invited },
];

export type CreateInPerson = Omit<Create, "personID">;

export type CreateInPersonRequiredKey = Exclude<CreateRequiredKey, "personID">;

export type CreateInPersonSubset<K extends keyof CreateInPerson = keyof CreateInPerson> = Pick<
	CreateInPerson,
	CreateInPersonRequiredKey | K
>;

export const blankItemInPerson: CreateInPerson = omitKeys(initialCreate, ["personID"]);
